import type { ComponentProps } from 'react';

import { Stack } from '@eneco/sparky';

import { stackContainerClass } from './selfservice.css';

export const StackContainer = (props: ComponentProps<typeof Stack>) => (
  <Stack className={stackContainerClass} {...props} />
);
